import React, { createContext, useState, useContext, useEffect } from 'react';
import { getSummary, checkHealth } from '../api';
import toast from 'react-hot-toast';

const MpesaContext = createContext();

export const useMpesaContext = () => {
  const context = useContext(MpesaContext);
  if (!context) {
    throw new Error('useMpesaContext must be used within MpesaProvider');
  }
  return context;
};

export const MpesaProvider = ({ children }) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [serverStatus, setServerStatus] = useState('checking');

  const fetchSummary = async () => {
    try {
      setLoading(true);
      const response = await getSummary();
      setSummary(response.data);
    } catch (error) {
      console.error('Error fetching summary:', error);
      toast.error('Failed to load summary data');
    } finally {
      setLoading(false);
    }
  };

  const checkServer = async () => {
    try {
      await checkHealth();
      setServerStatus('online');
    } catch (error) {
      setServerStatus('offline');
      toast.error('Server is not responding');
    }
  };

  useEffect(() => {
    checkServer();
    fetchSummary();
    const interval = setInterval(fetchSummary, 30000);
    return () => clearInterval(interval);
  }, []);

  const value = {
    summary,
    loading,
    serverStatus,
    fetchSummary,
    checkServer,
  };

  return (
    <MpesaContext.Provider value={value}>
      {children}
    </MpesaContext.Provider>
  );
};